// src/components/kiosk/POSSection/SectionSelector.jsx
function SectionSelector({ selectedSection, onSelectSection }) {
  const sections = [
    { name: 'Salon', color: '#10b981', gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' },
    { name: 'Spa', color: '#a855f7', gradient: 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)' },
    { name: 'Gym', color: '#3b82f6', gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }
  ];

  // If a section is selected, don't show the selector
  if (selectedSection) {
    return null;
  }

  return (
    <div style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Title */}
      <div className="text-center mb-6 md:mb-12">
        <h1 className="text-2xl md:text-5xl font-bold text-white mb-3" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
          Point of Sale
        </h1>
        <div style={{ width: '6rem', height: '4px', background: '#ffffff', margin: '0 auto', borderRadius: '2px' }} />
        <p className="text-sm md:text-xl mt-3" style={{ color: 'rgba(255,255,255,0.9)' }}>
          Select a section to begin
        </p>
      </div>

      {/* Section Cards — 1 col mobile, 3 col desktop */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 max-w-5xl mx-auto">
        {sections.map((section) => (
          <button
            key={section.name}
            onClick={() => onSelectSection(section.name)}
            className="text-xl md:text-4xl font-bold"
            style={{
              padding: '2rem 1.5rem',
              border: 'none',
              borderRadius: '1.5rem',
              background: section.gradient,
              color: '#ffffff',
              fontWeight: '700',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.3s ease',
              fontFamily: 'Inter, sans-serif',
              minHeight: '120px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
            }}
          >
            <div style={{ position: 'absolute', width: '150px', height: '150px', borderRadius: '50%', background: 'rgba(255,255,255,0.1)', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', filter: 'blur(40px)' }} />
            <span style={{ position: 'relative', zIndex: 1 }}>{section.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default SectionSelector;